import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { Grid, MenuItem, TextField, Typography, useTheme } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { MenuProps } from "src/components/hook-form/RHFSelectMulti";
import { ordersUpdate } from "src/pages/api";
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MultipleOrderUpdate({ data, onClose }) {
  const theme = useTheme();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const [status, setSelectedStatus] = React.useState("");

  const mutation = useMutation(req => ordersUpdate({ req }), {
    onSuccess: () => {
      enqueueSnackbar(`status Updated`, {
        variant: "success",
      });
      queryClient.invalidateQueries(["courier-orderList"]);
      onClose();
    },
    onError: error => {
      enqueueSnackbar(error?.message || "Failed to Update", {
        variant: "error",
      });
    },
  });

  const handleUpdate = () => {
    if (!status) {
      enqueueSnackbar(`Please Select Status`, {
        variant: "error",
      });
      return;
    }
    const req = {
      orderID: data.map(el => el?.original?.orderID).join(","),
      status: status,
    };
    mutation.mutate(req);
    // return;
  };
  return (
    <Dialog
      open
      TransitionComponent={Transition}
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-slide-description">
          <Grid container spacing={3}>
          <Grid item xs={12}>
              <Typography 
                variant="body2"
                sx={{ 
                  color: theme.palette.text.primary,
                  fontWeight: 600,
                  mb: 1
                }}
              >
                Selected Order Id:
              </Typography>
              <Typography 
                variant="body1"
                sx={{ 
                  color: theme.palette.text.primary,
                  wordBreak: "break-word",
                  backgroundColor: theme.palette.mode === 'dark' 
                    ? theme.palette.grey[800] 
                    : theme.palette.grey[100],
                  borderRadius: 1,
                  p: 1,
                  fontSize: '0.875rem'
                }}
              >
                {data.map(el => el?.original?.orderID).join(", ")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Select Status"
                select
                size="small"
                SelectProps={{ native: false, MenuProps: MenuProps }}
                fullWidth
                onChange={e => {
                  setSelectedStatus(e.target.value);
                }}
                value={status}
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {[
                  { label: "Delivered", value: 6 },
                  { label: "RTO", value: 10 },
                ].map(el => (
                  <MenuItem value={el.value} key={el.value}>
                    {el.label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={handleUpdate}
          color="primary"
          variant="contained"
          loading={mutation.isLoading}
          disabled={!status}
        >
          Update
        </LoadingButton>
        <Button onClick={onClose} color="error" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
